import React, { useEffect, useReducer, useState } from 'react';
import { IconButton, Button, Checkbox, FormControlLabel } from '@material-ui/core';
import CancelIcon from '@material-ui/icons/Cancel';
import { createHotelPackage, updateHotelPackage } from '../../../../../utils/ServicesAPIUtils';
import { notificationManager } from '../../../../../utils/NotificationUtils';
import CustomTextField from '../../../../../shared/form-controls/custom-text-field/Custom-Text-Field';
import { useDispatch } from 'react-redux';
import { fetchAllAccommodations } from '../../../../property/propertySlice';
import './Package-Create.scss';
import { formDataValidate } from '../../../../../utils/formUtils';
import { decryptLocalStorage } from '../../../../../utils/authUtils';
import { stepDownLoaderCount, stepUpLoaderCount } from '../../../../../utils/loaderSlice';

const PackageCreate = (props) => {
  const { toggleDrawer, packageObj, hotelId, showLoader = () => {} } = props;
  const dispatch = useDispatch();
  const [isTabInValid, setIsTabInValid] = useState(true);
  const [formData, setFormData] = useReducer((state, newState) => ({ ...state, ...newState }), {
    name: {
      value: '',
      fieldName: 'Package Name',
      errors: {},
      validations: ['required'],
      tab: 0,
    },
    code: {
      value: '',
      fieldName: 'Package Code',
      errors: {},
      validations: ['required', 'validAlphaNumeric'],
      tab: 0,
    },
    description: {
      value: '',
      fieldName: 'Description',
      errors: {},
      validations: ['required'],
      tab: 0,
    },
    costPerNight: {
      value: '',
      fieldName: 'Cost per night',
      errors: {},
      validations: ['required', 'positiveOnlyWithZero'],
      tab: 0,
    },
    isActive: {
      value: false,
      fieldName: '',
      errors: {},
      validations: [],
      tab: 0,
    },
  });

  useEffect(() => {
    if (packageObj) {
      const currFields = { ...formData };
      for (let field in currFields) {
        currFields[field].value = packageObj[field];
      }
      setFormData(currFields);
    }
  }, [packageObj]);

  const handleActiveChange = (event) => {
    const currField = { ...formData.isActive };
    currField.value = event.target.checked;
    setFormData({ isActive: currField });
  };

  const validate = () => {
    const updatedFields = {};
    const isValid = formDataValidate(formData, updatedFields);
    setFormData(updatedFields);
    return isValid;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (validate()) {
      try {
        dispatch(stepUpLoaderCount());
        toggleDrawer('', false, '');
        const selectedLanguage = decryptLocalStorage('lang');
        const language = selectedLanguage !== 'en' ? selectedLanguage : '';
        const payload = {};

        for (let field in formData) {
          payload[field] = formData[field].value;
        }

        if (packageObj) {
          payload.id = packageObj.id;
          await updateHotelPackage(payload, hotelId, language);
          notificationManager('success', 'Package updated successfully');
        } else {
          await createHotelPackage(payload, hotelId, language);
          notificationManager('success', 'Package created successfully');
        }

        dispatch(fetchAllAccommodations(hotelId));
      } catch (error) {
        if (error?.graphQLErrors) {
          notificationManager('danger', error?.graphQLErrors?.[0]?.message);
        } else {
          packageObj
            ? notificationManager('danger', 'Package updation failed')
            : notificationManager('danger', 'Package creation failed');
        }
      } finally {
        dispatch(stepDownLoaderCount());
      }
    }
  };

  const onCancel = (e) => {
    toggleDrawer('', false, '');
  };

  useEffect(() => {
    const isValid = formDataValidate(formData, false);
    setIsTabInValid(!isValid);
  }, [formData]);

  return (
    <form onSubmit={handleSubmit} className='package-create' noValidate>
      <div className='container pt-4 d-flex align-items-end flex-column '>
        <div className='row px-3 w-100 mt-4'>
          <div className='col-md-6'>
            <span className='page-title'>{packageObj ? 'Edit Package' : 'Add Package'}</span>
          </div>
          <div className='col-md-6 d-flex justify-content-end'>
            <IconButton aria-label='delete' onClick={(e) => onCancel(e)}>
              <CancelIcon />
            </IconButton>
          </div>
        </div>
        <div className='row px-3 w-100 d-flex mt-4 form-scroll'>
          <div className='row px-3 w-100 mt-4'>
            <div className='col-md-6'>
              <div className='page-title-secondary'>Details</div>
            </div>
          </div>
          <div className='row px-3 w-100 d-flex mt-2'>
            <div className='row'>
              <div className='col-md-6 mb-3'>
                <CustomTextField
                  item={formData.name}
                  handleInputChange={(e) => {
                    setFormData({ name: e });
                  }}
                  maxLength={100}
                  endAdornment={true}
                  characterCount={true}
                  multiline={true}
                />
              </div>
              <div className='col-md-6 mb-3'>
                <CustomTextField
                  item={formData.code}
                  handleInputChange={(e) => {
                    setFormData({ code: e });
                  }}
                  multiline={true}
                />
              </div>
            </div>
            <div className='row'>
              <div className='col-md-12 mb-3'>
                <CustomTextField
                  item={formData.description}
                  multiline={true}
                  handleInputChange={(e) => {
                    setFormData({ description: e });
                  }}
                />
              </div>
            </div>
            <div className='row'>
              <div className='col-md-6 mb-3'>
                <CustomTextField
                  type='number'
                  item={formData.costPerNight}
                  handleInputChange={(e) => {
                    setFormData({ costPerNight: e });
                  }}
                  min={0}
                  max={99999999}
                />
              </div>
            </div>
            <div className='row'>
              <div className='col-md-6 mb-3 mx-2'>
              <FormControlLabel
                control={
                <Checkbox
                  checked={formData.isActive.value}
                  onChange={handleActiveChange}
                  className='status-checkbox'
                  color='primary'
                />}
                  label='Active'
               />
                {' '}
              </div>
            </div>
          </div>
        </div>
        <div className='row mx-2 mt-auto px-4 w-100 pb-5'>
          <div className='col-md-12 d-flex justify-content-start'>
            <Button
              variant='contained'
              type='submit'
              color='primary'
              className='me-3'
              size='large'
              disabled={isTabInValid}
            >
              {packageObj ? 'Update' : 'Add'}
            </Button>
            <Button
              variant='outlined'
              type='button'
              color='secondary'
              size='large'
              onClick={(e) => onCancel(e)}
            >
              Cancel
            </Button>
          </div>
        </div>
      </div>
    </form>
  );
};

export default PackageCreate;
